import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'

import { parseMessages } from 'helpers/parse-dll-error'
import { prepareData } from 'helpers/prepare-req-data'
import client from 'api'
import _ from 'lodash'


const initialState = {
    startKtgDimStatus: 'idle',
    startKtgDimError: undefined as any,
    loadParamsKtgDimStatus: 'idle',
    loadParamsKtgDimError: undefined as any,
    loadColumnConfigsStatus: 'idle',
    loadColumnConfigsError: undefined as any,

    ktgDimList: [] as any[],
    colConfigs: undefined as any,
    filterValues: {} as any,
    filterLookupValues: {} as any,
}

export const startKtgDim = createAsyncThunk('ktgDimSlice/startKtgDim', async (ktgDim: any, { rejectWithValue }: any) => {
    const res = await client.post(`/api/ixweb/startKtgDim/`, prepareData(ktgDim))

    // check type of response -  winrest or backend
    if (typeof(res.data) === 'object' && res.data.hasOwnProperty('status')) {  // winrest response
        if (res.data.status === 'Failed') {
            return rejectWithValue(parseMessages(res.data.messages))
        } else {
            return { ...ktgDim, HDR_ID: res.data.data.id }
        }
    } else {  // backend response
        return res.data
    }
})
export const loadParamsKtgDim = createAsyncThunk('ktgDimSlice/loadParamsKtgDim', async (_, { rejectWithValue }: any) => {
    const res = await client.get(`/api/ixweb/loadParamsKtgDim/`)

    // check type of response -  winrest or backend
    if (typeof(res.data) === 'object' && res.data.hasOwnProperty('status')) {  // winrest response
        if (res.data.status === 'Failed') {
            return rejectWithValue(parseMessages(res.data.messages))
        } else {
            return res.data.data
        }
    } else {  // backend response
        return res.data
    }
})
export const loadColumnConfigs = createAsyncThunk('ktgDimSlice/loadColumnConfigs', async (_, { rejectWithValue }: any) => {
    const res = await client.get(`/api/ixweb/budim/`)

    // check type of response -  winrest or backend
    if (typeof(res.data) === 'object' && res.data.hasOwnProperty('status')) {  // winrest response
        if (res.data.status === 'Failed') {
            return rejectWithValue(parseMessages(res.data.messages))
        } else {
            return res.data.data
        }
    } else {  // backend response
        return res.data
    }
})

const KtgDimSlice = createSlice({
    name: 'ktgDimSlice',
    initialState,
    reducers: {
        resetstartKtgDimError: (state) => {
            state.startKtgDimError = undefined
        },
        resetloadParamsKtgDimError: (state) => {
            state.loadParamsKtgDimError = undefined
        },
        resetloadColumnConfigs: (state) => {
            state.colConfigs = undefined
            state.loadColumnConfigsError = undefined
        },
        resetloadColumnConfigsError: (state) => {
            state.loadColumnConfigsError = undefined
        },
        removeFromKtgDimListById: (state, action) => {
            state.ktgDimList = state.ktgDimList.filter((x: any) => x.HDR_ID !== action.payload)
        },
        setFilterValues: (state, action) => {
            if (action.payload === undefined || action.payload === null) {
                state.filterValues = {}
            } else {
                state.filterValues = { ...state.filterValues, ...action.payload }
            }
        },
        setFilterLookupValue: (state, action) => {
            const { name, value, formValue } = action.payload
            if (name) {
                state.filterLookupValues[name] = value
                state.filterValues[name] = formValue
            }
        },
    },
    extraReducers: builder => {
        builder.addCase(startKtgDim.pending, (state) => {
            state.startKtgDimStatus = 'pending'
            state.startKtgDimError = undefined
        })
        builder.addCase(startKtgDim.fulfilled, (state, action) => {
            state.startKtgDimStatus = 'idle'

            state.ktgDimList = [...state.ktgDimList, action.payload]
        })
        builder.addCase(startKtgDim.rejected, (state, action) => {
            state.startKtgDimStatus = 'error'
            if (action.error.message !== 'Rejected') {
                state.startKtgDimError = action.error.message
            } else {
                state.startKtgDimError = action.payload
            }
        })

        builder.addCase(loadParamsKtgDim.pending, (state) => {
            state.loadParamsKtgDimStatus = 'pending'
            state.loadParamsKtgDimError = undefined
        })
        builder.addCase(loadParamsKtgDim.fulfilled, (state, action) => {
            state.loadParamsKtgDimStatus = 'idle'

            state.ktgDimList = action.payload
        })
        builder.addCase(loadParamsKtgDim.rejected, (state, action) => {
            state.loadParamsKtgDimStatus = 'error'
            if (action.error.message !== 'Rejected') {
                state.loadParamsKtgDimError = action.error.message
            } else {
                state.loadParamsKtgDimError = action.payload
            }
        })

        builder.addCase(loadColumnConfigs.pending, (state) => {
            state.loadColumnConfigsStatus = 'pending'
            state.loadColumnConfigsError = undefined
        })
        builder.addCase(loadColumnConfigs.fulfilled, (state, action) => {
            state.loadColumnConfigsStatus = 'idle'

            state.colConfigs = action.payload
        })
        builder.addCase(loadColumnConfigs.rejected, (state, action) => {
            state.loadColumnConfigsStatus = 'error'
            if (action.error.message !== 'Rejected') {
                state.loadColumnConfigsError = action.error.message
            } else {
                state.loadColumnConfigsError = action.payload
            }
        })

    }
})

export const {
    resetstartKtgDimError,
    resetloadParamsKtgDimError,
    resetloadColumnConfigs,
    resetloadColumnConfigsError,
    removeFromKtgDimListById,
    setFilterValues,
    setFilterLookupValue,
} = KtgDimSlice.actions
export default KtgDimSlice.reducer
